import Vue from 'vue'
import VueRouter from 'vue-router'

import SelectPlanStep from '../components/subscription/SelectPlanStep';
import ChangePasswordForm from '../components/password/ChangePasswordForm';
import ResetPasswordForm from '../components/password/ResetPasswordForm';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/prenumerata'
  },
  {
    name: 'prenumerata',
    path: '/prenumerata',
    children: [
      { path: '/prenumerata', component: SelectPlanStep },
    ],
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Subscription.vue')
  },
  {
    name: 'zmiana_hasla',
    path: '/zmien_haslo',
    component: ChangePasswordForm
  },
  {
    name: 'reset_hasla',
    path: '/resetuj_haslo',
    component: ResetPasswordForm
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
